// src/components/auth/ProtectedRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import LoadingSpinner from '../common/LoadingSpinner';

const ProtectedRoute = ({ children, requireAdmin = false, requireManager = false }) => {
    const { isAuthenticated, isAdmin, isManager, loading } = useAuth();

    //console.log('ProtectedRoute check:', { isAuthenticated, isAdmin, isManager, requireAdmin, requireManager }); // Debug log

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <LoadingSpinner size="lg" />
            </div>
        );
    }

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    if (requireAdmin && !isAdmin) {
        //console.log('Admin required but user is not admin, redirecting based on role');
        // Redirect managers back to manager portal, others to employee portal
        if (isManager) {
            return <Navigate to="/manager/dashboard" />;
        }
        return <Navigate to="/employee/dashboard" />;
    }

    if (requireManager && !isManager && !isAdmin) {
        //console.log('Manager required but user is not manager, redirecting to employee portal');
        return <Navigate to="/employee/dashboard" />;
    }

    return children;
};

export default ProtectedRoute;